<template>
  <div class="col-12">
    <div class="row">
      <div class="col-12 mb-3">
        <h5 class="card-title">Was möchten Sie vermarkten?</h5>
      </div>
    </div>
    <div class="row align-items-center mt-3">
      <div class="col-12 col-lg-6 font-bold">
        Welches Objekt?
      </div>
      <div class="col-12 col-lg-6">
        <Field as="select" v-model="surveyStore.data.unterkunfts_typ" id="unterkunfts_typ" name="unterkunfts_typ"
               class="form-select" :class="{'is-invalid': errors.unterkunfts_typ}">
          <option value="">--- Wählen Sie einen Objekttyp ---</option>
          <option value="ferienhaeuser">Ferienhaus</option>
          <option value="ferienwohnungen">Ferienwohnung</option>
          <option value="hotels">Hotel</option>
          <option value="pensionen">Pension</option>
          <option value="hostels">Hostel</option>
          <option value="jugendherberge">Jugendherberge</option>
          <option value="heuherbergen">Heuherberge</option>
          <option value="schwimmende-unterkuenfte">Hausboot</option>

          <!-- EXTRA-Abfrage! -->
          <option value="campingunterkunft">Camping</option>
          <option value="ferienparks">Ferienpark</option>
          <option value="ferienhoefe">Ferienhof</option>
<!--          <option value="erlebnispark">Erlebnispark</option> -->
        </Field>
      </div>
    </div>
  </div>
</template>

<script>
import {useSurveyStore} from "../../../stores/survey";
import {Field} from 'vee-validate';

export default {
  components: {
    Field,
  },
  setup() {
    return {
      surveyStore: useSurveyStore(),
    }
  },
  data() {
    return {}
  },
  props: {
    errors: Object,
  },
  methods: {},

}
</script>
